import React from 'react';

//@ts-ignore
import UploadComponent from './UploadComponent';

export function Upload({ editor, handleUpload, setFolderUid, loading, selected }) {
    return (
        <UploadComponent loading={loading} editor={editor} handleUpload={handleUpload} setFolderUid={setFolderUid} selected={selected} />
    )
}
